import addedLeadIcon from 'assets/salesReports/addedLead.svg';
import PropTypes from 'prop-types';

import {
  Icon,
  IconWrapper,
  Label,
  RevenueContainer,
  Text,
  Value,
} from './TotalRevenue.styles';

const TotalRevenue = ({ onClick, backgroundColor = 'white', color = '#10B981' }) => {
  return (
    <RevenueContainer onClick={onClick} backgroundColor={backgroundColor}>
      <Label>$ Total Revenue</Label>
      <Value $color={color}>$ 31,379.808</Value>
      <IconWrapper>
        <Icon src={addedLeadIcon} alt={'leadIcon'} />
        <Text $color={color}>From 4 converted leads</Text>
      </IconWrapper>
    </RevenueContainer>
  );
};

TotalRevenue.propTypes = {
  icon: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string,
  trend: PropTypes.oneOf(['up', 'down']),
  trendValue: PropTypes.number,
  onClick: PropTypes.func,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
};

export default TotalRevenue;
